import { render } from "./m-bet-area.vue?vue&type=template&id=f3320f20&scoped=true&ts=true"
import script from "./m-bet-area.vue?vue&type=script&lang=ts"
export * from "./m-bet-area.vue?vue&type=script&lang=ts"

import "./m-bet-area.vue?vue&type=style&index=0&id=f3320f20&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3320f20"]])

export default __exports__